export const selectIsTheme = state => state.theme.isTheme;
